(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ai-parallax-panels-stacked"] && !Shopify.designMode) return;
  try {
    
(() => {
  const ROOT_SEL  = '[data-ai-parallax-panels]';
  const BLOCK_SEL = '.ai-parallax-panels__block';
  const INNER_SEL = '.ai-parallax-panels__media-inner';
  const STAGE_SEL = '.ai-parallax-panels__media-stage';

  const instances = new Map();
  let rafId = null;

  const prefersReduced = () =>
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const clamp01    = (n) => Math.max(0, Math.min(1, n));
  const smoothstep = (t) => t * t * (3 - 2 * t);

  function parsePxVar(root, name, fallback) {
    const v = getComputedStyle(root).getPropertyValue(name).trim();
    const n = parseFloat(v);
    return Number.isFinite(n) ? n : fallback;
  }

  function readSettings(root) {
    const strengthUi      = parseFloat(root.dataset.strength || '18');
    const strength        = clamp01(strengthUi / 100);
    const maxShiftDesktop = parsePxVar(root, '--ai-max-shift-desktop', 52);
    const maxShiftMobile  = parsePxVar(root, '--ai-max-shift-mobile',  26);
    return { strength, maxShiftDesktop, maxShiftMobile };
  }

  function init(root) {
    if (!root || instances.has(root)) return;

    root.dataset.js = 'ready';

    const blocks   = Array.from(root.querySelectorAll(BLOCK_SEL));
    const stages   = Array.from(root.querySelectorAll(STAGE_SEL));
    const settings = readSettings(root);

    // Reveal on scroll-into-view
    const revealIO = new IntersectionObserver((entries) => {
      for (const e of entries) {
        if (e.isIntersecting) e.target.dataset.visible = 'true';
      }
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });

    blocks.forEach(b => revealIO.observe(b));

    // Parallax: track which stages are on screen
    const activeStages = new Set();
    const parallaxIO   = new IntersectionObserver((entries) => {
      for (const e of entries) {
        if (e.isIntersecting) activeStages.add(e.target);
        else activeStages.delete(e.target);
      }
      scheduleUpdate();
    }, { threshold: 0, rootMargin: '120px 0px 120px 0px' });

    stages.forEach(s => parallaxIO.observe(s));

    function destroy() {
      revealIO.disconnect();
      parallaxIO.disconnect();
      instances.delete(root);
    }

    instances.set(root, { root, settings, blocks, stages, activeStages, destroy });
    scheduleUpdate();
  }

  function scheduleUpdate() {
    if (rafId != null) return;
    rafId = requestAnimationFrame(() => {
      rafId = null;
      updateAll();
    });
  }

  function updateAll() {
    if (prefersReduced()) return;

    const viewportH = window.innerHeight || document.documentElement.clientHeight;

    instances.forEach((inst) => {
      const { root, settings, activeStages } = inst;
      if (root.dataset.parallax !== 'true') return;

      const maxShift = (window.innerWidth < 750)
        ? settings.maxShiftMobile
        : settings.maxShiftDesktop;

      for (const stage of activeStages) {
        const inner = stage.querySelector(INNER_SEL);
        if (!inner) continue;

        const rect = stage.getBoundingClientRect();
        if (rect.bottom < 0 || rect.top > viewportH) continue;

        const t        = clamp01((viewportH - rect.top) / (viewportH + rect.height));
        const eased    = smoothstep(t);
        const centered = (eased - 0.5) * 2;
        const move     = centered * -maxShift * settings.strength;

        inner.style.setProperty('--ai-parallax-y', `${move.toFixed(2)}px`);
      }
    });
  }

  function initAll() {
    document.querySelectorAll(ROOT_SEL).forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once: true });
  } else {
    initAll();
  }

  window.addEventListener('scroll', scheduleUpdate, { passive: true });
  window.addEventListener('resize', scheduleUpdate, { passive: true });

  if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', () => {
      initAll();
      scheduleUpdate();
    });

    document.addEventListener('shopify:section:unload', (event) => {
      const id = event && event.detail && event.detail.sectionId;
      if (!id) return;
      document.querySelectorAll(`${ROOT_SEL}[data-section-id="${CSS.escape(id)}"]`).forEach((root) => {
        const inst = instances.get(root);
        if (inst) inst.destroy();
      });
    });

    document.addEventListener('shopify:section:select',  scheduleUpdate);
    document.addEventListener('shopify:block:select',    scheduleUpdate);
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ai-parallax-panels"] && !Shopify.designMode) return;
  try {
    
(() => {
  const ROOT_SEL = '[data-ai-parallax-panels]';
  const ROW_SEL = '.ai-parallax-panels__row';
  const INNER_SEL = '.ai-parallax-panels__media-inner';
  const STAGE_SEL = '.ai-parallax-panels__media-stage';

  const instances = new Map();
  let rafId = null;

  const prefersReduced = () =>
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const clamp01 = (n) => Math.max(0, Math.min(1, n));
  const smoothstep = (t) => t * t * (3 - 2 * t);

  function parsePxVar(root, name, fallback) {
    const v = getComputedStyle(root).getPropertyValue(name).trim();
    const n = parseFloat(v);
    return Number.isFinite(n) ? n : fallback;
  }

  function readSettings(root) {
    const strengthUi = parseFloat(root.dataset.strength || '18');
    const strength = clamp01(strengthUi / 100);

    const maxShiftDesktop = parsePxVar(root, '--ai-max-shift-desktop', 52);
    const maxShiftMobile = parsePxVar(root, '--ai-max-shift-mobile', 26);

    return { strength, maxShiftDesktop, maxShiftMobile };
  }

  function init(root) {
    if (!root || instances.has(root)) return;

    root.dataset.js = 'ready';

    const rows = Array.from(root.querySelectorAll(ROW_SEL));
    const mediaInners = Array.from(root.querySelectorAll(INNER_SEL));
    const stages = Array.from(root.querySelectorAll(STAGE_SEL));
    const settings = readSettings(root);

    const revealIO = new IntersectionObserver((entries) => {
      for (const e of entries) {
        if (e.isIntersecting) {
          e.target.dataset.visible = 'true';
        }
      }
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });

    rows.forEach(r => revealIO.observe(r));

    const activeStages = new Set();
    const parallaxIO = new IntersectionObserver((entries) => {
      for (const e of entries) {
        if (e.isIntersecting) activeStages.add(e.target);
        else activeStages.delete(e.target);
      }
      scheduleUpdate();
    }, { threshold: 0, rootMargin: '120px 0px 120px 0px' });

    stages.forEach(s => parallaxIO.observe(s));

    function destroy() {
      revealIO.disconnect();
      parallaxIO.disconnect();
      instances.delete(root);
    }

    instances.set(root, { root, settings, rows, mediaInners, stages, activeStages, destroy });
    scheduleUpdate();
  }

  function scheduleUpdate() {
    if (rafId != null) return;
    rafId = requestAnimationFrame(() => {
      rafId = null;
      updateAll();
    });
  }

  function updateAll() {
    if (prefersReduced()) return;

    const viewportH = window.innerHeight || document.documentElement.clientHeight;

    instances.forEach((inst) => {
      const { root, settings, mediaInners, stages, activeStages } = inst;
      if (root.dataset.parallax !== 'true') return;

      const maxShift = (window.innerWidth < 750) ? settings.maxShiftMobile : settings.maxShiftDesktop;

      for (const stage of activeStages) {
        const inner = stage.querySelector(INNER_SEL);
        if (!inner) continue;

        const rect = stage.getBoundingClientRect();
        if (rect.bottom < 0 || rect.top > viewportH) continue;

        const t = clamp01((viewportH - rect.top) / (viewportH + rect.height));
        const eased = smoothstep(t);
        const centered = (eased - 0.5) * 2;

        const move = centered * -maxShift * settings.strength;
        inner.style.setProperty('--ai-parallax-y', `${move.toFixed(2)}px`);
      }
    });
  }

  function initAll() {
    document.querySelectorAll(ROOT_SEL).forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once: true });
  } else {
    initAll();
  }

  window.addEventListener('scroll', scheduleUpdate, { passive: true });
  window.addEventListener('resize', scheduleUpdate, { passive: true });

  if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', (event) => {
      initAll();
      scheduleUpdate();
    });

    document.addEventListener('shopify:section:unload', (event) => {
      const id = event && event.detail && event.detail.sectionId;
      if (!id) return;

      document.querySelectorAll(`${ROOT_SEL}[data-section-id="${CSS.escape(id)}"]`).forEach((root) => {
        const inst = instances.get(root);
        if (inst) inst.destroy();
      });
    });

    document.addEventListener('shopify:section:select', scheduleUpdate);
    document.addEventListener('shopify:block:select', scheduleUpdate);
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-feature-cards-bento"] && !Shopify.designMode) return;
  try {
    
(() => {
  const ROOT_SEL = '[data-ai-feature-panels]';
  const ROW_SEL = '.ai-feature-panels__row';
  const INNER_SEL = '.ai-feature-panels__media-inner';
  const STAGE_SEL = '.ai-feature-panels__media-stage';

  const instances = new Map();
  let rafId = null;

  const prefersReduced = () =>
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const clamp01 = (n) => Math.max(0, Math.min(1, n));
  const smoothstep = (t) => t * t * (3 - 2 * t);

  function parsePxVar(root, name, fallback) {
    const v = getComputedStyle(root).getPropertyValue(name).trim();
    const n = parseFloat(v);
    return Number.isFinite(n) ? n : fallback;
  }

  function readSettings(root) {
    const strengthUi = parseFloat(root.dataset.strength || '18');
    const strength = clamp01(strengthUi / 100);
    const maxShiftDesktop = parsePxVar(root, '--ai-max-shift-desktop', 52);
    const maxShiftMobile = parsePxVar(root, '--ai-max-shift-mobile', 26);
    return { strength, maxShiftDesktop, maxShiftMobile };
  }

  function init(root) {
    if (!root || instances.has(root)) return;

    root.dataset.js = 'ready';

    const rows = Array.from(root.querySelectorAll(ROW_SEL));
    const mediaInners = Array.from(root.querySelectorAll(INNER_SEL));
    const stages = Array.from(root.querySelectorAll(STAGE_SEL));
    const settings = readSettings(root);

    const revealIO = new IntersectionObserver((entries) => {
      for (const e of entries) {
        if (e.isIntersecting) e.target.dataset.visible = 'true';
      }
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });

    rows.forEach(r => revealIO.observe(r));

    const activeStages = new Set();
    const parallaxIO = new IntersectionObserver((entries) => {
      for (const e of entries) {
        if (e.isIntersecting) activeStages.add(e.target);
        else activeStages.delete(e.target);
      }
      scheduleUpdate();
    }, { threshold: 0, rootMargin: '120px 0px 120px 0px' });

    stages.forEach(s => parallaxIO.observe(s));

    function destroy() {
      revealIO.disconnect();
      parallaxIO.disconnect();
      instances.delete(root);
    }

    instances.set(root, { root, settings, rows, mediaInners, stages, activeStages, destroy });
    scheduleUpdate();
  }

  function scheduleUpdate() {
    if (rafId != null) return;
    rafId = requestAnimationFrame(() => {
      rafId = null;
      updateAll();
    });
  }

  function updateAll() {
    if (prefersReduced()) return;

    const viewportH = window.innerHeight || document.documentElement.clientHeight;

    instances.forEach((inst) => {
      const { root, settings, activeStages } = inst;
      if (root.dataset.parallax !== 'true') return;

      const maxShift = (window.innerWidth < 750) ? settings.maxShiftMobile : settings.maxShiftDesktop;

      for (const stage of activeStages) {
        const inner = stage.querySelector(INNER_SEL);
        if (!inner) continue;

        const rect = stage.getBoundingClientRect();
        if (rect.bottom < 0 || rect.top > viewportH) continue;

        const t = clamp01((viewportH - rect.top) / (viewportH + rect.height));
        const eased = smoothstep(t);
        const centered = (eased - 0.5) * 2;

        const move = centered * -maxShift * settings.strength;
        inner.style.setProperty('--ai-parallax-y', `${move.toFixed(2)}px`);
      }
    });
  }

  function initAll() {
    document.querySelectorAll(ROOT_SEL).forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once: true });
  } else {
    initAll();
  }

  window.addEventListener('scroll', scheduleUpdate, { passive: true });
  window.addEventListener('resize', scheduleUpdate, { passive: true });

  if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', () => { initAll(); scheduleUpdate(); });
    document.addEventListener('shopify:section:unload', (event) => {
      const id = event && event.detail && event.detail.sectionId;
      if (!id) return;
      document.querySelectorAll(`${ROOT_SEL}[data-section-id="${CSS.escape(id)}"]`).forEach((root) => {
        const inst = instances.get(root);
        if (inst) inst.destroy();
      });
    });
    document.addEventListener('shopify:section:select', scheduleUpdate);
    document.addEventListener('shopify:block:select', scheduleUpdate);
  }
})();

  } catch(e) { console.error(e); }
})();
})();
